import baseApi from 'shared/api/baseApi';

import type { ToolCatalogResponse } from '../model/toolCatalog';

const toolsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getToolCatalog: build.query<ToolCatalogResponse, { projectId?: number }>({
      query: ({ projectId }) => ({
        url: '/admin/agentEvals/tools',
        method: 'GET',
        params: projectId !== undefined ? { projectId } : {},
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetToolCatalogQuery } = toolsApi;

export default toolsApi;
